import { render, staticRenderFns } from "./TypeColor.vue?vue&type=template&id=3d936020"
import script from "./TypeColor.vue?vue&type=script&lang=js"
export * from "./TypeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports